import { writable } from "svelte/store";

const { gold2gems, gems2gold } = GW2.config.offers;

function updateQuote(what2what, updated, idx = 0) {
    this.update((store) => {
        Object.assign(store[what2what][idx], updated);

        return store;
    });
}

// `idx`, `what2what`, and `notType` make things easier in `load-quotes.js`

export const standardQuotes = writable({
    gold2gems : gold2gems.map((amt, idx) => ({
        idx,
        what2what : "gold2gems",
        quantity  : amt,
        type      : "gems",
        notType   : "coins",
        command   : "ReceivingGems"
    })),
    gems2gold : gems2gold.map((amt, idx) => ({
        idx,
        what2what : "gems2gold",
        quantity  : amt,
        type      : "coins",
        notType   : "gems",
        command   : "ReceivingCoins"
    }))
});

standardQuotes.updateQuote = updateQuote.bind(standardQuotes);


export const customQuotes = writable({
    gold2gems : [{
        idx       : 0,
        what2what : "gold2gems",
        // this needs to use quantity from input field
        quantity  : gold2gems[gold2gems.length - 1],
        type      : "gems",
        notType   : "coins",
        command   : "ReceivingGems"
    }],
    gems2gold : [{
        idx       : 0,
        what2what : "gems2gold",
        // this needs to use quantity from input field
        quantity  : gems2gold[gems2gold.length - 1],
        type      : "coins",
        notType   : "gems",
        command   : "ReceivingCoins"
    }]
});

customQuotes.updateQuote = updateQuote.bind(customQuotes);
